// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
/*WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Inter:400,500,700&display=swap']
    },
    //,
    // typekit: {
    // id: 'XXXX'
    // },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});*/

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/isExternalLink');
require('./modules/accordion');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/fileUploadWithPreview');
require('./modules/menu');
require('./modules/searchToggle');
require('./modules/sideMenu');
require('./modules/tabs');
require('./modules/modal');
require('./modules/passwordReveal');
require('./modules/flex-components');
require('./modules/contact-textarea');

// check if user is logged in to couples corner (but not WP - so the admin bar is missing)
if (!$('.nojq').length) {
    $('.header').addClass('__noadminbar');
}